export default __webpack_public_path__ + "static/media/WoodSounds_Loop.38034f52.wav";